import RUF from "../../../util/redux";

export function modelSetResidenceType(state, action) {
  return RUF.updateObject(state, {
    model: RUF.updateObject(state.model, {
      residenceType: action.payload
    })
  });
}
